import { LocalThemeContextProvider } from '../../context';
import {
  FilterableScoreHealthRangeContextProvider,
  ScoreHealthRangeBreakpointLabels,
  ScoreHealthRangeContainer,
  ScoreHealthRangeContextProvider,
  ScoreHealthRangeGraphic,
  ScoreHealthRangeGraphicProps,
  ScoreHealthRangeGroupButton,
  ScoreHealthRangeGroupingContainer,
  useFilterableScoreHealthRange,
  UseFilterableScoreHealthRangeArgs,
  useScoreHealthRange,
  UseScoreHealthRangeArgs,
} from '..';
import { displayRate, elementsColors, getFormattedNumberLabel } from '../../../util';
import { displayElementScoreRangeCategory, isScorecardTermElement } from '../../../Scorecard';
import { useTranslation } from 'react-i18next';
export interface FilterableScoreHealthRangeProps
  extends UseFilterableScoreHealthRangeArgs,
    UseScoreHealthRangeArgs,
    Pick<ScoreHealthRangeGraphicProps, 'graphDots'> {
  className?: string;
  allowGroupSelection?: boolean;
}

export function FilterableScoreHealthRange({
  element,
  onChange,
  graphDots,
  className,
  breakpoints,
  allowGroupSelection,
  defaultSelectedBreakPointIDs,
}: // scoreBreakPointFiltersIsLoading, // TODO: use this to set loading state
FilterableScoreHealthRangeProps) {
  const { t: tScorecard } = useTranslation('scorecard');
  const useScoreHealthRangeReturn = useScoreHealthRange({ element, breakpoints });
  const useFilterableScoreHealthRangeReturn = useFilterableScoreHealthRange({ defaultSelectedBreakPointIDs, onChange });

  return (
    <ScoreHealthRangeContextProvider element={element} {...useScoreHealthRangeReturn}>
      <FilterableScoreHealthRangeContextProvider
        allowGroupSelection={allowGroupSelection}
        {...useFilterableScoreHealthRangeReturn}
      >
        <LocalThemeContextProvider paletteSeedColor={elementsColors[element]}>
          <ScoreHealthRangeContainer className={className}>
            <ScoreHealthRangeBreakpointLabels
              displayBreakpoints={useScoreHealthRangeReturn.displayBreakpoints.map((point) =>
                isScorecardTermElement(element)
                  ? getFormattedNumberLabel(point) ?? ''
                  : displayRate(point, { withSymbol: true })
              )}
            />
            <ScoreHealthRangeGraphic
              graphDots={graphDots}
              numberOfSections={useScoreHealthRangeReturn.numberOfSections}
            />
            <ScoreHealthRangeGroupingContainer>
              {useScoreHealthRangeReturn.breakpoints.map(
                ({ category, id }) =>
                  category &&
                  id && (
                    <ScoreHealthRangeGroupButton
                      key={id}
                      groupDisplay={displayElementScoreRangeCategory(category, tScorecard)}
                      breakpointID={id}
                    />
                  )
              )}
            </ScoreHealthRangeGroupingContainer>
          </ScoreHealthRangeContainer>
        </LocalThemeContextProvider>
      </FilterableScoreHealthRangeContextProvider>
    </ScoreHealthRangeContextProvider>
  );
}
